exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width: 1200px) {\n  .add-product-link {\n    display: none !important;\n  }\n\n  .header-profile-btn-wrap {\n    width: 33.333% !important;\n    max-width: 33.3333333% !important;\n  }\n}", ""]);

// exports
